import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auth-form-toggle"
export default class extends Controller {
  static targets = ["loginForm", "forgotPasswordForm"]
  static values = { showForgot: Boolean }

  connect() {
    if (this.showForgotValue) {
      this.showForgotPassword()
    }
  }

  showForgotPassword() {
      console.log("Start Showing forgot password form")
    if (!this.hasLoginFormTarget || !this.hasForgotPasswordFormTarget) return

    console.log("Showing forgot password form")
    this.loginFormTarget.classList.add("hidden")
    this.forgotPasswordFormTarget.classList.remove("hidden")
  }

  showLogin() {
    if (!this.hasLoginFormTarget || !this.hasForgotPasswordFormTarget) return

    this.forgotPasswordFormTarget.classList.add("hidden")
    this.loginFormTarget.classList.remove("hidden")
  }
}
